import { render, staticRenderFns } from "./MultiLoad.vue?vue&type=template&id=70b3ad66&scoped=true&lang=pug&"
import script from "./MultiLoad.vue?vue&type=script&lang=js&"
export * from "./MultiLoad.vue?vue&type=script&lang=js&"
import style0 from "./MultiLoad.vue?vue&type=style&index=0&id=70b3ad66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3ad66",
  null
  
)

export default component.exports